import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';

export const CHANNELS_LOADING = "CHANNELS_LOADING";
export const CHANNELS_SUCCESS = "CHANNELS_SUCCESS";
export const CHANNELS_FAILED = "CHANNELS_FAILED";

export const FETCH_WA_FROM_NUMBER_LOADING: string = "FETCH_WA_FROM_NUMBER_LOADING";
export const FETCH_WA_FROM_NUMBER_SUCCESS: string = "FETCH_WA_FROM_NUMBER_SUCCESS";
export const FETCH_WA_FROM_NUMBER_FAILED: string = "FETCH_WA_FROM_NUMBER_FAILED";

export const fetchAllChannels = () => {

    return (dispatch: Dispatch<any>) => {
        dispatch({ type: CHANNELS_LOADING });
        networkCall("get", `/channels`, apiBaseUrl.baseUrlV2 )
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    dispatch({ type: CHANNELS_SUCCESS, payload: { res: res } });

                    if (res.wa_pricing_plan && res.country_fees) {
                        dispatch({
                            type: 'SET_WA_PRICING_PLAN_DATA',
                            payload: {
                                wa_pricing_plan: res.wa_pricing_plan,
                                country_fees: res.country_fees,
                            },
                        });
                    }
                } else {
                    dispatch({ type: CHANNELS_FAILED, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: CHANNELS_FAILED, payload: { error: error.response.data } });
                }
            });
    }
}

export const sendSandboxMessage = (data: object, cb: (status: boolean, data: any) => void) => {
    return (dispatch: Dispatch<any>) => {
        networkCall("post", `/whatsapp/trysandbox`, apiBaseUrl.baseUrl, true, true, data)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    cb(true, { cost: res.cost, to: res.to });
                } else {
                    cb(false, res);
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    cb(false, error.response.data);
                }
            });
    }
}

export const getWaFromNumbers = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: FETCH_WA_FROM_NUMBER_LOADING });
        networkCall("get", `/whatsapp/from-numbers`, apiBaseUrl.baseUrl)
            .then((res: any) => {
                if (res.error && isEmpty(res.error)) {
                    dispatch({ type: FETCH_WA_FROM_NUMBER_SUCCESS, payload: { res: res } });
                } else {
                    dispatch({ type: FETCH_WA_FROM_NUMBER_FAILED, payload: { error: res } });
                }
            }).catch((error) => {
                if (error?.response?.data) {
                    dispatch({ type: FETCH_WA_FROM_NUMBER_FAILED, payload: { error: error.response.data } });
                }
            });
    }
}

export const getKycStatus = (callback: any) => {
    return () => {
        networkCall("get", '/whatsapp/is-embedded-signup-user', apiBaseUrl.baseUrl)
            .then((res: any) => {
                callback(res.data);
            }).catch((error) => {
                if (error?.response.data) {
                    callback(error?.response.data);
                }
            })
    }
}

export const submitEmbeddedSignup = (payload: any, callback: any) => {
    return () => {
        networkCall("post", `/whatsapp/embedded-signup`, apiBaseUrl.baseUrl, true, true, payload)
            .then((res: any) => {
                callback(res);
            }).catch((error) => {
                if (error?.response) {
                    callback(error?.response);
                }
            });
    }
}